import axios from 'axios';
import { toastError } from '@Utils/toastrHelper';

export const getBarcodeAuthToken = () => {
  const tokenStorageKey = process.env.TOKEN;

  if (tokenStorageKey) {
    const envToken = localStorage.getItem(tokenStorageKey);
    if (envToken) {
      return envToken;
    }
  }

  return localStorage.getItem('token') || localStorage.getItem('access_token');
};

export const openBarcodePrintWindow = async (barcodePrintUrl) => {
  const token = getBarcodeAuthToken();

  if (!token) {
    toastError('Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại');
    return false;
  }

  try {
    const response = await axios.get(barcodePrintUrl, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    });
    const blob = new Blob([response.data], {
      type: response.headers['content-type'] || 'text/html',
    });
    const downloadUrl = window.URL.createObjectURL(blob);
    const printWindow = window.open(downloadUrl, '_blank', 'noopener,noreferrer');

    if (!printWindow) {
      window.URL.revokeObjectURL(downloadUrl);
      toastError('Trình duyệt đang chặn popup in mã vạch');
      return false;
    }

    printWindow.onload = () => {
      window.URL.revokeObjectURL(downloadUrl);
    };

    return true;
  } catch (error) {
    toastError('Không thể in mã vạch, vui lòng thử lại');
    return false;
  }
};
